// extracted by mini-css-extract-plugin
export default {"controlDiv":"control_controlDiv__PHf7e","addIcon":"control_addIcon__0kiSz"};